<template>
  <span>{{ output }}</span>
</template>

<script setup>
import { USD } from '@/utils/currency'

/**
 * @typedef {Object} DollarCellParams
 * @param {String} value
 */
const props = defineProps({
  /** @type {DollarCellParams} */
  params: {
    type: Object,
    required: true
  }
})

const output = (() => {
  return props.params.value ? USD.format(props.params.value) : 'N/A'
})()
</script>
